
























import Vue from 'vue'

interface CComputed {
  firstChild: string
  allContent: any
  title: string
  content: string
  image: string
}

export default Vue.extend<{}, {}, CComputed, {}>({
  name: 'ParentPage',
  props: {},
  computed: {
    firstChild() {
      return this.$store.getters.routes[1]['name']
    },
    allContent() {
      return this.$store.getters.parentContent
    },
    title() {
      return this.allContent.title
    },
    content() {
      return this.allContent.content
    },
    image() {
      return this.allContent.image
    }
  }
})
